import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import BasicNumericInput from '../../../../../shared/components/formComponents/groups/BasicNumericInput';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class ShortEssaySectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        sectionItemId: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, sectionItemId, isGlobalSectionItem } = this.props;
        return (
            <div key={`${memberReference}-${sectionItemId}`} className={'col-12 shortEssaySectionItem'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            className={'col-12'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            rows={3}
                            readOnly={isGlobalSectionItem}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.characterLimit` : 'content.characterLimit'}
                        label={'Character Limit'}
                        className={'col-6'}
                        minValue={100}
                        maxValue={1000000}
                        disabled={isGlobalSectionItem}
                        component={BasicNumericInput}
                    />
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.hideCharacterCount`
                                : 'content.hideCharacterCount'
                        }
                        label={'Hide Char. Count'}
                        className={'col-6'}
                        disabled={isGlobalSectionItem}
                        component={BasicToggle}
                        id={'hide-char-count-toggle'}
                    />
                </div>
            </div>
        );
    }
}

export default ShortEssaySectionItem;
